import _ from "lodash";

export const TableHelper = {
  sorter: (tableParams) => {
    let sorter = null;
    if (tableParams.sorter !== undefined) {
      if (tableParams.sorter.column != undefined) {
        // orden de una sola columna
        sorter = `["${tableParams.sorter.order === "descend" ? "-" : ""}${
          tableParams.sorter.field
        }"]`;
      } else if (_.isArray(tableParams.sorter)) {
        // orden de varias columnas
        let array = "";
        sorter = tableParams.sorter.forEach((i) => {
          array += `${array !== "" ? "," : ""}"${
            i.order === "descend" ? "-" : ""
          }${i.field}"`;
        });
        sorter = `[${array}]`;
      }
    }
    return sorter;
  },
  sorterArray: (tableParams) => {
    let sorter = null;
    if (tableParams.sorter !== undefined) {
      if (tableParams.sorter.column != undefined) {
        // orden de una sola columna
        sorter = [
          `${tableParams.sorter.order === "descend" ? "-" : ""}${
            tableParams.sorter.field
          }`,
        ];
      } else if (_.isArray(tableParams.sorter)) {
        // orden de varias columnas
        let array = [];
        sorter = tableParams.sorter.forEach((i) => {
          array.push(`${i.order === "descend" ? "-" : ""}${i.field}`);
        });
        sorter = array;
      }
    }
    return sorter;
  },
};
